import AutoRedirect from './AutoRedirect'
export default AutoRedirect
